var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 57,
    rx: 11.5,
    stroke: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.036 12.7998C29.036 22.2746 19.3916 29.0894 19.3916 35.9046C19.3916 41.1372 23.7094 45.3791 29.036 45.3791C34.3618 45.3791 38.6793 41.1372 38.6793 35.9046C38.6793 29.0894 29.036 22.2746 29.036 12.7998ZM32.9157 40.7855H25.1548V38.7191L32.9157 38.7205V40.7855ZM32.9157 33.6362L30.0883 33.6348V36.4158H27.9816V33.6348H25.1545V31.5684H27.9816V28.7903H30.0883V31.5684H32.9157V33.6362Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/blood.9abb53a8da726bcab87bc3b0c8c3a6df.svg";
export { ForwardRef as ReactComponent };